var _polygon, _polygon2, _polygon3, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18,6 11,24 17,22 12,38 26,16 19,18",
    fill: "#000"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "38,2 31,20 37,18 32,34 46,12 39,14",
    fill: "#000"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "58,6 51,24 57,22 52,38 66,16 59,18",
    fill: "#000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 58,
    r: 13,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37,64 C30,58 20,55 15,50 C11,46 13,40 18,43 C23,46 30,54 37,60 Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63,64 C70,58 80,55 85,50 C89,46 87,40 82,43 C77,46 70,54 63,60 Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50,71 C34,71 20,77 16,90 L16,110 L84,110 L84,90 C80,77 66,71 50,71 Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/stress.cffc5ca7ca944f0e1a0f2edd207d6c25.svg";
export { ForwardRef as ReactComponent };